import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import {
  setStopResumePosition as setStopResumePositionUtil,
  clearStopResumePosition as clearStopResumePositionUtil,
} from '../../utils/stopResume'
import { VOD_MESSAGE_TYPES } from '../../constants'
import {
  setStopResumePosition,
  clearStopResumePosition,
  setPlayerError,
} from '../../actions'

const {
  STOP_RESUME_SAVE_REQUEST,
  PLAYER_ERROR,
} = VOD_MESSAGE_TYPES

export default function withVODPlayerEvents(WrappedComponent) {
  const WithPlayerEventsComponent = function WithPlayerEvents(props) {
    const dispatch = useDispatch()
    const episodeData = useSelector(state => state.episode.currentEpisode)
    const playerApiPath = useSelector(state => state.episode.playerApiPath)

    useEffect(() => {
      const handleMessage = ({ data }) => {
        const { type, body } = data
        switch (type) {
          case STOP_RESUME_SAVE_REQUEST: {
            if (episodeData && episodeData.episodeInfo.episodeId) {
              if (body.clearEntry) {
                clearStopResumePositionUtil({ id: episodeData.episodeInfo.episodeId })
                dispatch(clearStopResumePosition({
                  id: episodeData.episodeInfo.episodeId,
                }))
              } else {
                const position = body.time
                setStopResumePositionUtil({
                  duration: episodeData.video?.length,
                  expires: episodeData.episodeInfo?.availableUntil,
                  id: episodeData.episodeInfo.episodeId,
                  imageId: episodeData.episodeInfo?.imageId,
                  position,
                  programmeName: episodeData.programme?.name,
                  summary: episodeData.episodeInfo?.summary,
                  programmeGuid: episodeData.programme?.guid,
                  forceAds: episodeData.programme?.forceAds,
                  svodExclusive: episodeData.programme?.svodExclusive,
                })
                dispatch(setStopResumePosition({
                  id: episodeData.episodeInfo.episodeId,
                  path: playerApiPath,
                  position,
                }))
              }
            }
            break
          }

          case PLAYER_ERROR: {
            dispatch(setPlayerError(body.error))
            break
          }

          default: {
            break
          }
        }
      }

      window.addEventListener('message', handleMessage)
      return () => window.removeEventListener('message', handleMessage)
    }, [episodeData, playerApiPath, dispatch])

    return (episodeData || props.error) ? <WrappedComponent {...props} /> : null
  }

  WithPlayerEventsComponent.propTypes = {
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }

  WithPlayerEventsComponent.defaultProps = {
    error: null,
  }

  return WithPlayerEventsComponent
}
